import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import Daftar from './daftar';
import Form from './form';
import Alamat from './alamat';
import Info from './info';
import Otp from './otp';
import Pembayaran from './pembayaran';
import PrivateRoute from '../../components/routing/PrivateRoute';

function Register() {

  return (

    <Switch>
      <PrivateRoute path="/register/form" component={Form} />
      <PrivateRoute path="/register/pembayaran" component={Pembayaran} />
      <PrivateRoute path="/register/info" component={Info} />
      <PrivateRoute path="/register/alamat" component={Alamat} />
      <Route path="/register/otp/:phone/:timeOTP" component={Otp} />
      <Route path="/register" component={Daftar} />
      <Redirect to='/register' />
    </Switch>


  );
}

export default Register;